// src/services/api/raid.js
// Raid create, join, and leave functions.

import { fetchWithCommonHeaders, API_URL } from './helpers';

export const fetchRaidCreate = async (token, bossCode, time, message) => {
    const url = `${API_URL}v2/feed/raid/create`;
    const response = await fetchWithCommonHeaders(url, {
        method: "POST",
        token,
        body: {
            bossCode,
            time,
            message,
        },
    });
    if (!response.ok) {
        let errorResult = "error";
        try {
            const data = await response.json();
            if (data && data.result) {
                errorResult = data.result;
            }
        } catch (e) {}
        const err = new Error(errorResult);
        err.response = response;
        err.result = errorResult;
        throw err;
    }
    return response.json();
};

export const fetchRaidJoin = async (token, eventId) => {
    const url = `${API_URL}v2/feed/raid/join`;
    const response = await fetchWithCommonHeaders(url, {
        method: "POST",
        token,
        body: {
            eventId,
        },
    });
    if (!response.ok) {
        let errorResult = "error";
        try {
            const data = await response.json();
            if (data && data.result) {
                errorResult = data.result;
            }
        } catch (e) {}
        const err = new Error(errorResult);
        err.response = response;
        err.result = errorResult;
        throw err;
    }
    return response.json();
};

export const fetchRaidLeave = async (token, eventId) => {
    const url = `${API_URL}v2/feed/raid/leave`;
    const response = await fetchWithCommonHeaders(url, {
        method: "POST",
        token,
        body: {
            eventId,
        },
    });
    if (!response.ok) {
        let errorResult = "error";
        try {
            const data = await response.json();
            if (data && data.result) {
                errorResult = data.result;
            }
        } catch (e) {}
        const err = new Error(errorResult);
        err.response = response;
        err.result = errorResult;
        throw err;
    }
    return response.json();
};
